import type { DerivedMuahangPalette } from './deriveAccentPalette'

/** Đồng bộ token bảng / cột đọc từ CSS var + fallback. */
export function applyMuahangCssVars(d: DerivedMuahangPalette): void {
  if (typeof document === 'undefined') return
  const s = document.documentElement.style
  s.setProperty('--muahang-primary', d.primaryMain)
  s.setProperty('--muahang-primary-dark', d.primaryDark)
  s.setProperty('--muahang-primary-light', d.primaryLight)
  s.setProperty('--muahang-header-bg', d.headerBg)
  s.setProperty('--muahang-nav-active-bg', d.navItemActiveBg)
  s.setProperty('--muahang-nav-active-hover-bg', d.navItemActiveBgHover)
  s.setProperty('--muahang-submenu-bg', d.kiotSubmenuPanelBg)
  s.setProperty('--muahang-invoice-thead-bg', d.invoiceTableHeaderBg)
  s.setProperty('--muahang-table-level2-head-bg', d.tableLevel2HeadBg)
  s.setProperty('--muahang-table-level2-head-border', d.tableLevel2HeadBorder)
  s.setProperty('--muahang-table-head-bg', d.tableHeadBg)
  s.setProperty('--muahang-table-head-border', d.tableHeadBorder)
  s.setProperty('--muahang-table-wrapper-border', d.tableWrapperBorder)
  s.setProperty('--muahang-table-cell-border', d.tableCellBorder)
  s.setProperty('--muahang-row-hover-bg', d.rowHoverBg)
  s.setProperty('--muahang-row-selected-bg', d.rowSelectedBg)
  s.setProperty('--muahang-row-selected-hover-bg', d.rowSelectedHoverBg)
  s.setProperty('--muahang-primary-surface', d.primarySurface)
  s.setProperty('--muahang-primary-surface-border', d.primarySurfaceBorder)
}
